import script from "./AsyncLoader.vue?vue&type=script&setup=true&lang=ts"
export * from "./AsyncLoader.vue?vue&type=script&setup=true&lang=ts"

import "./AsyncLoader.vue?vue&type=style&index=0&id=cdc370a8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cdc370a8"]])

export default __exports__